export enum QqGroupTypeEnum {
    open = "open",
    additional = "additional"
}